import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { Grid } from 'semantic-ui-react';

import LoadingComponent from '../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../app/stores/rootStore';
import BookingChart from './BookingChart';
import BookingFilters from './BookingFilters';

const BookingDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { isLoading, isLoaded } = rootStore.bookingStore;

  if (isLoading) return <LoadingComponent content="Loading..." />;

  return (
    <Grid>
      <Grid.Column width={8}>
        <BookingFilters />
      </Grid.Column>
      <Grid.Column width={16}>{isLoaded && <BookingChart />}</Grid.Column>
    </Grid>
  );
};

export default observer(BookingDashboard);
